import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-subtitle2 ellipsis" }
const _hoisted_2 = { class: "text-h4" }
const _hoisted_3 = { class: "text-italic" }

import { DeepReadonlyObject } from "rxdb"
import SfxCardCondensed from "src/components/card/SfxCardCondensed.vue"
import SfxDataPoint from "src/components/data-point/SfxDataPoint.vue"
import { getChangesDB, getDB } from "src/db/databases"
import { Log } from "src/util/classes/log"
import { fetchIssuePriorityListData } from "src/util/functions/entityData"
import { getIssueCardIcons } from "src/util/functions/issues"
import { getWorkOrderCorrectiveItemData } from "src/util/functions/workOrder"
import { getWorkOrderPriorityData } from "src/util/functions/workOrderPriority"
import { IconRowElement } from "src/util/types/components/sfxIconRow"
import { PayloadEntity } from "src/util/types/dataModels/genericObject"
import { Issue } from "src/util/types/dataModels/issue"
import { IssuePriority } from "src/util/types/dataModels/issuePriority"
import { WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"
import { WorkOrderCorrectiveItem } from "src/util/types/dataModels/workOrder"
import { computed, onBeforeMount, onMounted, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardIssueUnsubmittedWork',
  props: {
  issue: {
    type: Object as PropType<PayloadEntity<Issue>>,
    required: true,
  },

  workOrderId: {
    type: String,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()

const issueImage = ref<string | undefined>()
const issuePriority = ref<IssuePriority>()
const workDomain = ref<DeepReadonlyObject<WorkDomainWorkspace>>()
const workOrder = ref<WorkOrderCorrectiveItem>()
const iconRowRaw = ref<IconRowElement[]>([])
const iconRow = computed(() => iconRowRaw.value)

const labelProcedureSteps = t("sfxCard.issue_label_procedure_steps")
const labelNone = t("sfxCard.issue_no_procedure_steps")

const countTotalProcedures = computed(
  () =>
    (props.issue?.related_procedure_steps_select?.length || 0) +
    (props.issue?.related_procedure_steps_bool?.length || 0) +
    (props.issue?.related_procedure_steps_verify?.length || 0) +
    (props.issue?.related_procedure_steps_photo?.length || 0) +
    (props.issue?.related_procedure_steps_numeric?.length || 0)
)

//endregion

//region Lifecycle

onBeforeMount(async () => {
  await fetchIssuePriorityListData()
  issuePriority.value = await getIssuePriority()
  workDomain.value = await getWorkDomain()
  if (props.workOrderId) {
    workOrder.value = await getWorkOrderCorrectiveItemData(props.workOrderId)
  }

  iconRowRaw.value = await getIconRow()
})

onMounted(async () => {
  if (props.issue?.attachments?.length > 0) {
    issueImage.value = await getUnsubmittedImage(props.issue?.attachments[0])
  }
})

//endregion

//region Functions

async function getIconRow(): Promise<IconRowElement[]> {
  let workOrderPriority

  if (workOrder.value) {
    workOrderPriority = await getWorkOrderPriorityData(workOrder.value?.priority)
  }

  return getIssueCardIcons(issuePriority.value, workOrderPriority)
}

async function getIssuePriority() {
  try {
    const db = await getDB()

    const priorityInDb = await db.issue_priority
      .findOne({ selector: { id: props.issue?.priority } })
      .exec()

    return priorityInDb?.toJSON()
  } catch (error) {
    Log.error({ message: "Failed to get the Issue Priority.", error })
  }
}

async function getWorkDomain() {
  try {
    const db = await getDB()

    const workDomainInDb = await db.work_domain_workspace
      .findOne({ selector: { id: props.issue?.work_domain } })
      .exec()

    return workDomainInDb?.toJSON()
  } catch (error) {
    Log.error({ message: "Failed to get the Work Domain.", error })
  }
}

async function getUnsubmittedImage(unsubmittedImageId: string): Promise<string | undefined> {
  try {
    const db = await getChangesDB()
    const unsubmittedImage = await db.unsubmitted_attachment.findOne(unsubmittedImageId).exec()

    if (unsubmittedImage) {
      const blob = await fetch(unsubmittedImage.fileData).then((response) => response.blob())

      return URL.createObjectURL(blob)
    }
  } catch (error) {
    Log.error({
      message: "An error occurred while trying to fetch the unsubmitted image",
      error,
    })
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _directive_truncate_middle = _resolveDirective("truncate-middle")!

  return (_openBlock(), _createBlock(SfxCardCondensed, {
    "img-src": issueImage.value,
    "icon-row": iconRow.value,
    hasImg: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(workDomain.value?.designation), 1),
      _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
        [_directive_truncate_middle, props.issue?.title]
      ]),
      (countTotalProcedures.value > 0)
        ? (_openBlock(), _createBlock(SfxDataPoint, {
            key: 0,
            label: _unref(labelProcedureSteps),
            "card-field": ""
          }, null, 8, ["label"]))
        : (_openBlock(), _createBlock(SfxDataPoint, {
            key: 1,
            label: _unref(labelProcedureSteps),
            "card-field": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(labelNone)), 1)
            ]),
            _: 1
          }, 8, ["label"]))
    ]),
    _: 1
  }, 8, ["img-src", "icon-row"]))
}
}

})